<template>
  <i-modal
    :value="show"
    :closable="false"
    :mask-closable="false"
    footer-hide
    width="860px"
    class="pdf-player-modal">
    <div class="modal-content" @contextmenu.prevent>
      <div class="close-btn" @click="$emit('close-modal')">
        <i-icon type="ios-close" />
      </div>
      <div v-if="mediaType === 'pdf'" class="pdf-player">
        <div v-if="loadedProgress !== 100" class="progress-bar">
          <div class="progress-bar-inner" :style="{ width: `${loadedProgress}%` }"></div>
        </div>
        <pdf
          class="pdf-item"
          v-for="i in totalPage"
          :key="i"
          :src="url"
          :page="i"
          @page-loaded="pdfPageLoaded"></pdf>
      </div>
    </div>
  </i-modal>
</template>

<script>
import pdf from 'vue-pdf';

export default {
  name: 'PdfPlayerModal',
  components: {
    pdf,
  },
  props: {
    show: { type: Boolean, required: true },
    mediaType: { type: String },
    url: { type: String, required: true },
  },
  data() {
    return {
      realUrl: '',
      totalPage: 0,
      loadedPage: 0,
      loadedProgress: 0,
    };
  },
  watch: {
    url: {
      immediate: true,
      handler() {
        if (this.mediaType === 'pdf') {
          this.loadedProgress = 0;
          // setTimeout(() => {
          //   if (this.loadedProgress === 0) {
          //     this.loadedProgress = 10;
          //   }
          // }, 1200);

          pdf.createLoadingTask(this.url).promise.then((result) => {
            this.totalPage = result._pdfInfo.numPages;
          });
        }
      },
    },
  },
  methods: {
    pdfPageLoaded() {
      this.loadedPage += 1;

      this.loadedProgress = (this.loadedPage / this.totalPage) * 100;
    },
  },
};
</script>

<style lang="less" scoped>
.pdf-player-modal {
  /deep/ .ivu-modal-content {
    border-radius: 0;
  }

  /deep/ .ivu-modal-body {
    padding: 0;
  }
}

.modal-content {
  position: relative;
  padding: 12px;

  > .close-btn {
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    top: 0;
    right: 0;
    transform: translateX(50%) translateY(-50%);
    width: 32px;
    height: 32px;
    border-radius: 50%;
    background-color: rgba(0, 0, 0, .52);
    cursor: pointer;

    > i {
      font-size: 32px;
      color: #fff;
    }
  }
}

.pdf-player {
  position: relative;
  width: 100%;
  height: 100%;
  max-height: 80vh;
  overflow-x: hidden;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 60px 40px;
  background-color: #535659;

  .pdf-item {
    margin-bottom: 20px;
    // margin: 0 auto;
    // width: 80%;

    &:last-of-type {
      margin-bottom: 0;
    }
  }

  .progress-bar {
    // position: sticky;
    // position: -webkit-sticky;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 3000;
    width: 100%;
    height: 4px;

    &-inner {
      width: 0%;
      height: 100%;
      border-radius: 4px;
      background-color: #047dee;
      transition: all .32s linear;
    }
  }
}
</style>
